"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _flex = _interopRequireDefault(require("../../../flex"));

var _link = _interopRequireDefault(require("../../../link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkOption = function LinkOption(_ref) {
  var url = _ref.url,
      func = _ref.func,
      label = _ref.label;
  return (0, _core.jsx)(_react.default.Fragment, null, url ? (0, _core.jsx)(_link.default, {
    href: url,
    target: "_blank",
    "data-qa": label
  }, label) : (0, _core.jsx)(_link.default, {
    onClick: func,
    "data-qa": label
  }, label));
};

var DefaultText = (
/*#__PURE__*/
0, _styledBase.default)(function (_ref2) {
  var className = _ref2.className,
      qaSelector = _ref2.qaSelector,
      label = _ref2.label;
  return (0, _core.jsx)("span", {
    className: className,
    "data-qa": qaSelector
  }, label);
}, {
  target: "e1b9izu10"
})("overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", function (props) {
  return props.isBold && "\n    font-weight: ".concat(props.theme.fonts.weight[4], ";\n  ");
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9mb3JtLWlucHV0cy90eXBlLWFoZWFkL2N1c3RvbS1vcHRpb25zL2RlZmF1bHQtb3B0aW9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCRSIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvZm9ybS1pbnB1dHMvdHlwZS1haGVhZC9jdXN0b20tb3B0aW9ucy9kZWZhdWx0LW9wdGlvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCBGbGV4IGZyb20gJy4uLy4uLy4uL2ZsZXgnO1xuaW1wb3J0IExpbmsgZnJvbSAnLi4vLi4vLi4vbGluayc7XG5cbmNvbnN0IExpbmtPcHRpb24gPSAoeyB1cmwsIGZ1bmMsIGxhYmVsIH0pID0+IChcbiAgPFJlYWN0LkZyYWdtZW50PlxuICAgIHt1cmxcbiAgICAgID8gPExpbmsgaHJlZj17dXJsfSB0YXJnZXQ9XCJfYmxhbmtcIiBkYXRhLXFhPXtsYWJlbH0gPntsYWJlbH08L0xpbms+XG4gICAgICA6IDxMaW5rIG9uQ2xpY2s9e2Z1bmN9IGRhdGEtcWE9e2xhYmVsfSA+e2xhYmVsfTwvTGluaz59XG4gIDwvUmVhY3QuRnJhZ21lbnQ+XG4pO1xuXG5jb25zdCBEZWZhdWx0VGV4dCA9IHN0eWxlZCgoeyBjbGFzc05hbWUsIHFhU2VsZWN0b3IsIGxhYmVsIH0pID0+IChcbiAgPHNwYW4gY2xhc3NOYW1lPXtjbGFzc05hbWV9IGRhdGEtcWE9e3FhU2VsZWN0b3J9PntsYWJlbH08L3NwYW4+XG4pKWBcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG5cbiAgJHtwcm9wcyA9PiBwcm9wcy5pc0JvbGQgJiYgYFxuICAgIGZvbnQtd2VpZ2h0OiAke3Byb3BzLnRoZW1lLmZvbnRzLndlaWdodFs0XX07XG4gIGB9O1xuYDtcblxuY29uc3QgT3B0aW9uID0gKHsgcWFTZWxlY3RvciwgbGFiZWwsIGhpbnQgfSkgPT5cbiAgaGludCAmJiBoaW50Lmxlbmd0aCA+IDBcbiAgICA/IDxGbGV4IGZsZXhEaXJlY3Rpb249J2NvbHVtbic+XG4gICAgICA8RGVmYXVsdFRleHQgcWFTZWxlY3Rvcj17cWFTZWxlY3Rvcn0gbGFiZWw9e2xhYmVsfSBpc0JvbGQ9e3RydWV9IC8+XG4gICAgICA8ZGl2PntoaW50fTwvZGl2PlxuICAgIDwvRmxleD5cbiAgICA6IDxEZWZhdWx0VGV4dCBxYVNlbGVjdG9yPXtxYVNlbGVjdG9yfSBsYWJlbD17bGFiZWx9IC8+O1xuXG5leHBvcnQgZGVmYXVsdCAoeyBxYVNlbGVjdG9yLCBsYWJlbCwgaXNMaW5rLCBoaW50LCBmdW5jLCB1cmwgfSkgPT5cbiAgPFJlYWN0LkZyYWdtZW50PlxuICAgIHtpc0xpbmsgJiYgdXJsIHx8IGZ1bmNcbiAgICAgID8gPExpbmtPcHRpb24gdXJsPXt1cmx9IGZ1bmM9e2Z1bmN9IGxhYmVsPXtsYWJlbH0gLz5cbiAgICAgIDogPE9wdGlvbiBxYVNlbGVjdG9yPXtxYVNlbGVjdG9yfSBsYWJlbD17bGFiZWx9IGhpbnQ9e2hpbnR9IC8+fVxuICA8L1JlYWN0LkZyYWdtZW50PjtcbiJdfQ== */"));

var Option = function Option(_ref3) {
  var qaSelector = _ref3.qaSelector,
      label = _ref3.label,
      hint = _ref3.hint;
  return hint && hint.length > 0 ? (0, _core.jsx)(_flex.default, {
    flexDirection: "column"
  }, (0, _core.jsx)(DefaultText, {
    qaSelector: qaSelector,
    label: label,
    isBold: true
  }), (0, _core.jsx)("div", null, hint)) : (0, _core.jsx)(DefaultText, {
    qaSelector: qaSelector,
    label: label
  });
};

var _default = function _default(_ref4) {
  var qaSelector = _ref4.qaSelector,
      label = _ref4.label,
      isLink = _ref4.isLink,
      hint = _ref4.hint,
      func = _ref4.func,
      url = _ref4.url;
  return (0, _core.jsx)(_react.default.Fragment, null, isLink && url || func ? (0, _core.jsx)(LinkOption, {
    url: url,
    func: func,
    label: label
  }) : (0, _core.jsx)(Option, {
    qaSelector: qaSelector,
    label: label,
    hint: hint
  }));
};

exports.default = _default;